export default __webpack_public_path__ + "post_project.be58a07b.png";